module.exports = __webpack_public_path__ + "static/media/06-pistol-poem.d4c22c92.mp3";